import Hashids from 'hashids';
import crypto from 'crypto-js';

const hashids = new Hashids("N3xTl0op", 8);

export function encodeFirestoreId(firestoreId) {
  const hash = crypto.SHA256(firestoreId).toString(crypto.enc.Hex);
  const shortHash = hash.substring(0, 12); // use fewer chars to stay under 53 bits
  const num = parseInt(shortHash, 16); // safe up to 2^53-1
  return hashids.encode(num);
}

// console.log(encodeFirestoreId('ynfZDOHu1uKXhakk9zWd'));
